var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", { staticClass: "font-weight-bold" }, [
        _vm._v("Plantilla de la estampa")
      ]),
      _c("p", { staticClass: "small text-muted mb-3" }, [
        _vm._v(" Configure cada línea de texto que aparecerá en su firma. ")
      ]),
      _vm._l(_vm.lines, function(line, index) {
        return _c(
          "div",
          { key: index, staticClass: "border rounded p-3 mb-3 bg-light" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center mb-2"
              },
              [
                _c("small", { staticClass: "font-weight-bold text-muted" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        line.type === "F"
                          ? "Firma manuscrita"
                          : "Línea " + (index + 1)
                      ) +
                      " "
                  )
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0 mr-2",
                        attrs: {
                          variant: "link",
                          size: "sm",
                          disabled: index === 0,
                          title: "Subir"
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveLine(index, -1)
                          }
                        }
                      },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "ArrowUpIcon", size: "14" }
                        })
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0 mr-2",
                        attrs: {
                          variant: "link",
                          size: "sm",
                          disabled: index === _vm.lines.length - 1,
                          title: "Bajar"
                        },
                        on: {
                          click: function($event) {
                            return _vm.moveLine(index, 1)
                          }
                        }
                      },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "ArrowDownIcon", size: "14" }
                        })
                      ],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0 text-danger",
                        attrs: {
                          variant: "link",
                          size: "sm",
                          title: "Eliminar"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeLine(index)
                          }
                        }
                      },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "TrashIcon", size: "14" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            line.type === "F"
              ? [
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col-3" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Pos. X")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: line.x,
                            expression: "line.x",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        attrs: { type: "number" },
                        domProps: { value: line.x },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(line, "x", _vm._n($event.target.value))
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-3" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Pos. Y")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: line.y,
                            expression: "line.y",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        attrs: { type: "number" },
                        domProps: { value: line.y },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(line, "y", _vm._n($event.target.value))
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-2" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Ancho")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: line.ax,
                            expression: "line.ax",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        attrs: {
                          type: "number",
                          min: "0",
                          title: "0 = respeta el tamaño original"
                        },
                        domProps: { value: line.ax },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(line, "ax", _vm._n($event.target.value))
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-2" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Alto")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: line.ay,
                            expression: "line.ay",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        attrs: {
                          type: "number",
                          min: "0",
                          title: "0 = respeta el tamaño original"
                        },
                        domProps: { value: line.ay },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(line, "ay", _vm._n($event.target.value))
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-2 d-flex align-items-end flex-column justify-content-end"
                      },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "mb-1",
                            attrs: {
                              variant: "outline-secondary",
                              size: "sm",
                              block: "",
                              title:
                                "Ajustar el ancho y alto para que la firma quepa en la estampa"
                            },
                            on: {
                              click: function($event) {
                                return _vm.fitSignatureLine(index)
                              }
                            }
                          },
                          [_vm._v(" Ajustar ")]
                        ),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "outline-secondary",
                              size: "sm",
                              block: "",
                              title: "Centrar en la estampa"
                            },
                            on: {
                              click: function($event) {
                                return _vm.centerSignatureLine(index)
                              }
                            }
                          },
                          [_vm._v(" Centrar ")]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      'Se insertará la imagen de representación visual (firma manuscrita) configurada. Use 0 en Ancho o Alto para respetar el tamaño original de la imagen. "Ajustar" fija el ancho/alto al tamaño de la estampa; "Centrar" la posiciona al medio.'
                    )
                  ])
                ]
              : [
                  _c("div", { staticClass: "row mb-2" }, [
                    _c("div", { staticClass: "col-2" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Tamaño")]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: line.size,
                              expression: "line.size"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                line,
                                "size",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.sizeOptions, function(s) {
                          return _c(
                            "option",
                            { key: s, domProps: { value: s } },
                            [_vm._v(_vm._s(s))]
                          )
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticClass: "col-2" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Estilo")]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: line.font,
                              expression: "line.font"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                line,
                                "font",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "B" } }, [
                            _vm._v("Negrita")
                          ]),
                          _c("option", { attrs: { value: "P" } }, [
                            _vm._v("Normal")
                          ]),
                          _c("option", { attrs: { value: "I" } }, [
                            _vm._v("Cursiva")
                          ])
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-2" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Color")]),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: line.color,
                              expression: "line.color"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                line,
                                "color",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "black" } }, [
                            _vm._v("Negro")
                          ]),
                          _c("option", { attrs: { value: "gray" } }, [
                            _vm._v("Gris")
                          ]),
                          _c("option", { attrs: { value: "blue" } }, [
                            _vm._v("Azul")
                          ]),
                          _c("option", { attrs: { value: "red" } }, [
                            _vm._v("Rojo")
                          ])
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-3" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Pos. X")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: line.x,
                            expression: "line.x",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        attrs: { type: "number", min: "0", max: "200" },
                        domProps: { value: line.x },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(line, "x", _vm._n($event.target.value))
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "col-3" }, [
                      _c("label", { staticClass: "small" }, [_vm._v("Pos. Y")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: line.y,
                            expression: "line.y",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control form-control-sm",
                        attrs: { type: "number", min: "0", max: "50" },
                        domProps: { value: line.y },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(line, "y", _vm._n($event.target.value))
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ])
                  ]),
                  _c("div", [
                    _c("label", { staticClass: "small" }, [_vm._v("Texto")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: line.text,
                          expression: "line.text"
                        }
                      ],
                      ref: "lineInput" + index,
                      refInFor: true,
                      staticClass: "form-control form-control-sm",
                      attrs: {
                        type: "text",
                        placeholder: "Escriba o inserte una variable..."
                      },
                      domProps: { value: line.text },
                      on: {
                        focus: function($event) {
                          _vm.focusedLineIndex = index
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(line, "text", $event.target.value)
                        }
                      }
                    })
                  ])
                ]
          ],
          2
        )
      }),
      _c(
        "div",
        { staticClass: "d-flex mb-3" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: { variant: "outline-secondary", size: "sm" },
              on: { click: _vm.addLine }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-1",
                attrs: { icon: "PlusIcon", size: "14" }
              }),
              _vm._v(" Agregar línea de texto ")
            ],
            1
          ),
          _c(
            "b-button",
            {
              attrs: {
                variant: "outline-info",
                size: "sm",
                disabled: _vm.hasSignatureLine
              },
              on: { click: _vm.addSignatureLine }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-1",
                attrs: { icon: "ImageIcon", size: "14" }
              }),
              _vm._v(" Agregar firma manuscrita ")
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "mb-3" }, [
        _c("label", { staticClass: "small font-weight-bold text-muted" }, [
          _vm._v("Variables disponibles:")
        ]),
        _c(
          "div",
          { staticClass: "d-flex flex-wrap gap-1 mt-1" },
          _vm._l(_vm.variables, function(variable) {
            return _c(
              "b-button",
              {
                key: variable.value,
                staticClass: "mr-1 mb-1",
                attrs: {
                  variant: "outline-info",
                  size: "sm",
                  title: variable.description
                },
                on: {
                  click: function($event) {
                    return _vm.insertVariable(variable.value)
                  }
                }
              },
              [_vm._v(" " + _vm._s(variable.label) + " ")]
            )
          }),
          1
        )
      ]),
      _c("div", { staticClass: "mt-3" }, [
        _c(
          "a",
          {
            staticClass: "small text-muted",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggleAdvanced($event)
              }
            }
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.showAdvanced
                    ? "Ocultar modo avanzado"
                    : "Modo avanzado (editar código)"
                ) +
                " "
            )
          ]
        ),
        _vm.showAdvanced
          ? _c("textarea", {
              staticClass: "form-control mt-2",
              staticStyle: { "font-size": "12px", "font-family": "monospace" },
              attrs: { rows: "4" },
              domProps: { value: _vm.serialized },
              on: {
                input: function($event) {
                  return _vm.onAdvancedInput($event.target.value)
                }
              }
            })
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }